<template>
  <div class="login_content">
    <van-nav-bar
      left-text="返回"
      @click="$router.go(-1)"
      left-arrow
      title="登录"
    />
    <div class="login_logo">
      <van-image
        round
        width="110px"
        height="110px"
        src="https://fastly.jsdelivr.net/npm/@vant/assets/cat.jpeg"
      />
    </div>
    <van-form @submit="Login">
      <van-cell-group inset>
        <van-field
          v-model="Account"
          name="用户名"
          label="用户名"
          placeholder="用户名"
          :rules="[{ required: true, message: '请填写用户名' }]"
        />
        <van-field
          v-model="Password"
          type="password"
          name="密码"
          label="密码"
          placeholder="密码"
          :rules="[{ required: true, message: '请填写密码' }]"
        />
      </van-cell-group>
      <div style="margin: 16px">
        <p>
          <router-link to="register"> 注册 </router-link>
        </p>
        <van-button round block type="primary" native-type="submit">
          登录
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script >
import axios from "../../commons/AxiosMethod.js"
import { showToast } from "vant"
export default {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data () {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      Password: "",
      Account: ""
    }
  },
  name: "App",

  components: {},
  mounted () {},
  methods: {
    Login () {
      var param = {
        Account: this.Account,
        Password: this.Password
      }
      axios.apiMethod("/Home/Login", "post", param, (result) => {
        if (result.Code == 200) {
          localStorage.setItem(
            "Authentication_Header",
            "Bearer " + result.Token
          )
          this.$router.push({
            path: "takeOutHome"
          })
        } else {
          showToast({
            type: "html",
            message: "登录失败,账号或者密码错误"
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login_logo {
  width: 100%;
  text-align: center;
  margin-top: 40px;
  height: 150px;
}
</style>
